<template>
  <b-modal
    id="m-Mensagens"
    size="lg"
    hide-footer
    no-close-on-backdrop
  >
    <template #modal-header="{ close }">
      <h5 class="mt-50">
        Mensagens da caixa postal
      </h5>
      <div class="float-right">
        <b-btn
          v-if="(!ocultarEmail)"
          v-b-tooltip.hover
          title="Enviar por e-mail"
          variant="none"
          class="btn-none icone-acao my-0 mx-50 p-0"
          @click="enviarMensagem"
        >
          <feather-icon
            icon="SendIcon"
            class="text-primary"
            size="20"
          />
        </b-btn>
        <b-btn
          v-if="linha.temAnexo"
          v-b-tooltip.hover
          title="Anexos"
          variant="none"
          class="btn-none icone-acao m-0 p-0"
          style="padding: 0.4rem;"
          :disabled="!linha.anexos"
          @click="abrirAnexos()"
        >
          <feather-icon
            icon="PaperclipIcon"
            :class="'text-primary'"
            size="17"
          />
        </b-btn>
        <b-btn
          class="btn-outline-secondary my-0 mx-50 p-50 rounded"
          @click="close()"
        >
          <font-awesome-icon icon="fa-solid fa-xmark" />
        </b-btn>
      </div>
    </template>
    <template #modal-title>
      Mensagens da caixa postal
    </template>
    <tabela-repeticao
      v-model="rows"
      :colunas="colunas"
      somente-visualizacao
      borda
      style="margin-left: 1%; max-width: 98%;"
    >

      <template #visualizacao="{slotScope: {valor}}">
        <span
          class="ml-20"
        >
          {{ valor }}
        </span>
      </template>
    </tabela-repeticao>
    <div
      v-if="linha"
      class="mensagem-tela"
      v-html="linha.mensagem"
    />
  </b-modal>
</template>

<script>
export default {
  components: {
    TabelaRepeticao: () => import('@pilar/components/tabela-repeticao/TabelaRepeticao.vue'),
  },
  props: {
    linha: {
      default: null,
      type: Object,
    },
    ocultarEmail: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      colunas: [
        {
          key: 'lidoPor', label: 'LIDO POR',
        },
        {
          key: 'dataLeitura', label: 'DATA DE LEITURA',
        },
        {
          key: 'usuario', label: 'USUÁRIO QUE REALIZOU A LEITURA',
        },
      ],
      isLoading: false,
      noStacking: true,
    }
  },
  computed: {
    rows() {
      if (!this.linha) {
        return []
      }
      return [
        {
          lidoPor: this.linha.lidoPor,
          dataLeitura: this.linha.dataPrimeiraLeitura,
          usuario: this.linha.usuarioAbriu,
        },
      ]
    },
  },
  methods: {
    enviarMensagem() {
      this.$emit('enviarMensagem')
    },
    abrirAnexos() {
      this.$emit('abrirAnexos')
    },
    abrirModal() {
      this.$refs.modalEnviarEmail.show()
    },
  },
}
</script>
